export function reviewsFilterGetPopupContainer(triggerNode: HTMLElement): HTMLElement {
    return triggerNode.parentNode as HTMLElement;
}

export const reviewsFilterDropdownStyle = {
    overflowY: 'auto' as const,
    zIndex: 9999,
};
